import React from 'react';
import Layout from '../components/Layout';
import Appointment from '../sections/Appointment/Appointment';
import Banner from '../sections/Banner/Banner';
// import Blogs from '../sections/Blogs/Blogs';
import Emergency from '../sections/Emergency/Emergency';
import Expert from '../sections/Expert/Expert';
import FeaturedServices from '../sections/FeaturedServices/FeaturedServices';
import Features from '../sections/Features/Features';
import ContactForm from '../components/ContactForm/ContactForm';

const Home = () => {
    return (
        <Layout>
            <Banner/>
            <FeaturedServices/>
            <Emergency/>
            <Features />
            <Expert/>
            {/* <Testimonial/> */}
            {/* <Blogs/> */}
            <Appointment/>
            {/* <ContactForm/> */}
        </Layout>
    );
};

export default Home;